import * as E from "../../either";
import { fromValidate, validate, fail } from "../validated";
import { validationException } from "../validation-exception";
/**
 * First successful validation is the result
 * If all fail - the last error is returned
 */
export function union(...args) {
    const [first, ...rest] = args;
    return first == undefined
        ? fail(validationException("Union of zilch"))
        : fromValidate((x) => rest.reduce((e, t) => E.alt(e, validate(t, x)), validate(first, x)));
}

